import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(''); // 'success', 'error', or ''
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);
    setStatus('');

    // Validate email
    if (!email || !email.includes('@')) {
      setStatus('error');
      setLoading(false);
      console.error('Invalid email format');
      return;
    }

    try {
      console.log('Attempting to save email to Firestore:', email);

      // Check if db is initialized
      if (!db) {
        throw new Error('Firestore not initialized');
      }

      // Save email to Firestore
      await setDoc(doc(db, 'newsletter', email), {
        email: email,
        subscribedAt: new Date().toISOString(),
      });

      console.log('Email saved successfully!');
      setStatus('success');
      setEmail(''); // Clear the form
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      console.error('Error code:', error.code);
      console.error('Error message:', error.message);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__content">
          <div className="footer__section">
            <h4 className="footer__title">Information</h4>
            <ul className="footer__links">
              <li><Link to="/under-construction">About</Link></li>
              <li><Link to="/under-construction">Sustainability</Link></li>
              <li><Link to="/under-construction">Size Guide</Link></li>
              <li><Link to="/under-construction">Product Care</Link></li>
              <li><Link to="/under-construction">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">Customer Service</h4>
            <ul className="footer__links">
              <li><Link to="/under-construction">Shipping & Returns</Link></li>
              <li><Link to="/under-construction">Terms & Conditions</Link></li>
              <li><Link to="/under-construction">Privacy Policy</Link></li>
              <li><Link to="/under-construction">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer__section footer__newsletter">
            <h4 className="footer__title">Newsletter</h4>
            <p className="footer__text">
              Subscribe to receive updates, access to exclusive deals, and more.
            </p>
            <form className="footer__form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                className="footer__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
              <button
                type="submit"
                className="footer__submit"
                disabled={loading}
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            {status === 'success' && (
              <p className="footer__message footer__message--success">
                Thank you for subscribing!
              </p>
            )}
            {status === 'error' && (
              <p className="footer__message footer__message--error">
                Something went wrong. Please try again.
              </p>
            )}
            <div className="footer__social">
              <a href="https://www.instagram.com/bluehourlab" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <rect x="2" y="2" width="16" height="16" rx="4" stroke="currentColor" strokeWidth="1.5"/>
                  <circle cx="10" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/>
                  <circle cx="15" cy="5" r="1" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M12 7V5C12 4.44772 12.4477 4 13 4H14V1H12C9.79086 1 8 2.79086 8 5V7H6V10H8V19H11V10H13L14 7H12Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </a>
              <a href="https://twitter.com" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M19 3C18.2 3.4 17.3 3.7 16.4 3.8C17.3 3.2 18 2.3 18.3 1.3C17.4 1.8 16.4 2.2 15.4 2.4C14.5 1.5 13.3 1 12 1C9.5 1 7.5 3 7.5 5.5C7.5 5.9 7.5 6.2 7.6 6.5C3.8 6.3 2 4.5 1 2C0.6 2.7 0.4 3.5 0.4 4.3C0.4 5.9 1.2 7.3 2.4 8.1C1.7 8.1 1 7.9 0.4 7.6V7.7C0.4 9.9 2 11.7 4.1 12.1C3.7 12.2 3.3 12.3 2.9 12.3C2.6 12.3 2.3 12.3 2 12.2C2.6 14 4.3 15.3 6.4 15.3C4.8 16.6 2.8 17.3 0.6 17.3C0.2 17.3 0 17.3 0 17.3C2.2 18.7 4.8 19.5 7.5 19.5C16 19.5 20.5 12.3 20.5 6C20.5 5.8 20.5 5.6 20.5 5.4C21.3 4.7 22 3.9 22.5 3C21.7 3.4 20.8 3.6 19 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; 2025 blue hour. All rights reserved.</p>
          <div className="footer__payment">
            <span>Visa</span>
            <span>Mastercard</span>
            <span>Amex</span>
            <span>PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
